import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Person',
    field: 'person',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'personId',
      // localKey: 'id',
      // fk: 'personId',
      namespace: 'person',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Comment',
    field: 'comment',
    // component: inputTextField({ type: 'textarea', req: false, max: 8192 })
    component: null
  }),
  createColumn({
    label: 'Attending',
    field: 'attending',
    defaultValue: true,
    type: 'boolean',
    component: null
    // component: booleanComponent
  }),
  createColumn({
    label: 'Event',
    field: 'event',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'eventId',
      // localKey: 'id',
      // fk: 'personId',
      namespace: 'event',
      filterIs: 'text-filter'
    }),
    component: null
  }),
  createColumn({
    label: 'Event Team',
    field: 'eventTeam',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'eventTeamId',
      // localKey: 'id',
      // fk: 'personId',
      namespace: 'event',
      filterIs: 'text-filter'
    }),
    component: null
  }),
  createColumn({
    label: 'Purchase',
    field: 'purchase',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'purchaseId',
      // localKey: 'id',
      // fk: 'personId',
      namespace: 'purchase',
      filterIs: 'text-filter'
    }),
    component: null
  })
].concat(defaultColumns)
